import styles from './Chrome.module.css';

export default function Chrome() {
  return (
    <div className={styles.chrome} aria-hidden="true">
      <div className={`${styles.edge} ${styles.top}`} />
      <div className={`${styles.edge} ${styles.left}`} />
      <div className={`${styles.edge} ${styles.right}`} />
    </div>
  );
}
